import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import React, { useEffect, useRef, useState } from 'react';
import { useIsMinWidth } from '@hooks/use-is-min-width';
import { navDefaultProps, navPropTypes } from './nav-prop-types';

import { Pill } from '../pill';
import { MoreSelect } from './more-select';
import { NavItem, NavLink } from './styles';
import { Flex } from '../grid';

const PageNav = ({
  itemsWrapperRef,
  navItemsCount,
  selectedSectionId,
  handlePageScroll,
  navItems,
  itemRefs,
  handleItemClick,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const handleClick = itemId => {
    setIsOpen(!isOpen);

    if (itemId) {
      handleItemClick(itemId);
    }
  };

  const handleClickOutside = event => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const isLg = useIsMinWidth('lg');

  const navigationItemCount = isLg ? navItemsCount : navItems.length;

  return (
    <Flex ref={itemsWrapperRef}>
      <Flex onScroll={handlePageScroll} gap="12px">
        {navItems.slice(0, navigationItemCount).map(item => (
          <Pill
            key={item.id}
            isActive={selectedSectionId === item.id}
            initialText={item.label}
            onClick={() => handleItemClick(item.id)}
            ref={itemRefs[item.id]}
          />
        ))}
        {navItems.length > navigationItemCount && (
          <MoreSelect
            isOpen={isOpen}
            navItems={navItems.slice(navItemsCount)}
            onClick={handleClick}
            selectRef={selectRef}
            selectedSectionId={selectedSectionId}
          >
            {navItems.slice(navItemsCount).map(
              item =>
                item && (
                  <NavItem
                    onClick={() => handleClick(item.id)}
                    py="14px"
                    px="20px"
                    as="button"
                    active={selectedSectionId === item.id}
                    key={item.id}
                  >
                    <NavLink>{item.label}</NavLink>
                  </NavItem>
                )
            )}
          </MoreSelect>
        )}
      </Flex>
    </Flex>
  );
};

PageNav.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  ...navPropTypes,
  itemsWrapperRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]).isRequired,
  navItemsCount: PropTypes.number.isRequired,
};

PageNav.defaultProps = navDefaultProps;
const ObservedNav = observer(PageNav);

export { ObservedNav as Nav };
